module.exports = __webpack_public_path__ + "static/media/image1.d7e5670f.jpg";